import { render, staticRenderFns } from "./AttachmentApplicationData.vue?vue&type=template&id=16bcd142"
import script from "./AttachmentApplicationData.vue?vue&type=script&lang=js"
export * from "./AttachmentApplicationData.vue?vue&type=script&lang=js"
import style0 from "./AttachmentApplicationData.vue?vue&type=style&index=0&id=16bcd142&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports